module.exports = __webpack_public_path__ + "img/vip2.dbb8387b.png";